import { useCallback, useEffect } from 'react';
import { useLazyGetWBSequentialMapDataQuery } from 'services/api/Meteorology/Agro/WaterBalanceSequential/Maps';
import { ResponseError } from 'services/api/base';
import useMapParams from './useMapParams';

export default function useMapData() {
  const params = useMapParams();
  const [trigger, { data, error, isFetching }] = useLazyGetWBSequentialMapDataQuery();

  useEffect(() => {
    if (params) {
      trigger(params);
    }
  }, [params, trigger]);

  const onRetry = useCallback(() => {
    if (params) trigger(params);
  }, [params, trigger]);

  return {
    mapData: data,
    queryError: error as ResponseError | undefined,
    onRetry,
    loading: isFetching,
  };
}
